import { Button, Typography } from '@breetometer/components';
import { TradeStockIcon } from 'BreetAssets';
import { capitalizeFirstLetter, type CURRENCYCODETYPE, formatCurrencyAmount, FXRATE, type ISellAssets } from 'BreetHelpers';
import { useCurrentFxRate, useUserCurrencyProps } from 'BreetHooks';
import { selectMarketAssetConverter, useAppSelector } from 'BreetRedux';

import { useRateCalculatorFormStageContext } from '../FormStageContext';

interface IAssetTransactionInfoProps {
	selectedAsset?: ISellAssets;
}

const AssetDetailsTransactionInfo = ({ selectedAsset }: IAssetTransactionInfoProps) => {
	const currencyProps = useUserCurrencyProps();

	const currentFxRate = useCurrentFxRate({ fxRate: FXRATE.DEFAULT });

	const { navigator } = useRateCalculatorFormStageContext();

	const marketAssetConverter = useAppSelector(selectMarketAssetConverter({ to: 'usd', from: selectedAsset?.symbol ?? '' }));

	return (
		<div className='asset-transaction-info border-top-dark-navy'>
			<Typography
				as='h6'
				className='color-primary-100'
			>
				{selectedAsset?.name} Info
			</Typography>
			<div className='asset-transaction-info-content border-dark-navy'>
				<div className='row'>
					<div className='left'>
						<Typography className='color-primary-100'>1 {selectedAsset?.name}</Typography>
					</div>
					<div className='right'>
						<Typography className='color-neutral-50'>
							{formatCurrencyAmount(marketAssetConverter.data?.data?.quote.USD.price ?? '0.00', 'USD')}
						</Typography>
					</div>
				</div>
				<div className='row'>
					<div className='left'>
						<Typography className='color-primary-100'>Current Crypto Rate</Typography>
					</div>
					<div className='right'>
						<Typography className='color-neutral-50'>
							<span>
								<span className='currency'>{currentFxRate.symbol.from}</span>&nbsp;
								{currentFxRate.rate}/<span className='currency dollar'>{currentFxRate.symbol.to}</span>
							</span>
						</Typography>
					</div>
				</div>
				<div className='row'>
					<div className='left'>
						<Typography className='color-primary-100'>Total {selectedAsset?.name} Received</Typography>
					</div>
					<div className='right'>
						<Typography className='color-neutral-50'>
							{selectedAsset?.stats.totalCrypto ?? '0.0'} {selectedAsset?.identifier}
						</Typography>
					</div>
				</div>
				<div className='row'>
					<div className='left'>
						<Typography className='color-primary-100'>Total USD Received</Typography>
					</div>
					<div className='right'>
						<Typography className='color-neutral-50'>
							{formatCurrencyAmount(selectedAsset?.stats.totalUSD ?? '0.00', 'USD')}
						</Typography>
					</div>
				</div>
				<div className='row'>
					<div className='left'>
						<Typography className='color-primary-100'>Total USD Payout</Typography>
					</div>
					<div className='right'>
						<Typography className='color-neutral-50'>
							{formatCurrencyAmount(selectedAsset?.stats.totalUSDSells ?? '0.00', 'USD')}
						</Typography>
					</div>
				</div>
				<div className='row'>
					<div className='left'>
						<Typography className='color-primary-100'>
							Total {capitalizeFirstLetter(currencyProps?.currencyShort)} Payout
						</Typography>
					</div>
					<div className='right'>
						<Typography className='color-neutral-50'>
							{formatCurrencyAmount(selectedAsset?.stats.totalFiat ?? '0.00', currencyProps?.code as unknown as CURRENCYCODETYPE)}
						</Typography>
					</div>
				</div>
				<div className='row-footer border-top-dark-navy'>
					<Button
						variant='tertiary'
						trailingIcon={<TradeStockIcon />}
						type='button'
						className='bg-tertiary-400 color-neutral-50 svg-light'
						onClick={navigator.goTo('rate-calculator')}
					>
						Check {selectedAsset?.name} Rate
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AssetDetailsTransactionInfo;
